<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="RouteVersionTable1" :fields="fields" :title="table_title.title1" :show_query_container="true"
        :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false" :show_toolbar="true" :show_filter="true"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy" :table_height_adjust="-6" @on_query="on_query"
        @state_change="state_change" :show_copy="true" :show_toolbar_button="[1, 1, 1, 1,1]" @tool_invoke="tool_invoke"
        @current_changed="current_changed" @on_cell_button_click="on_cell_button_click" tableref="afeebd6d914345b1b48e5041fe3ec807">
        <template #query>
          <el-input clearable size="small" style="width: 300px" placeholder="请输入物料编号、工艺路线名称（或编号）" v-model="RouteSearchText"></el-input>
        </template>
        <template #toolbar>
          <el-button type="info" plain @click="createForm()" class="ml-2 iconfont icon-add-new" size="mini"> {{$t("common.new")}}
          </el-button>
          <el-button type="info" plain class="ml-2" @click="RouteDiff"><i class="iconfont icon-contrast01"></i> 差异对比
          </el-button>
          <el-button type="info" plain class="ml-2" @click="InvokeData"><i class="iconfont icon-refresh"></i> 同步到AX
          </el-button>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 工艺路线版本 -->
    <BaseModal ref="route_version_table1_modal" :title="route_version_table1_modal_title" :width="'30%'" @saveData="RouteVersionSaveData">
      <template #modal_content>
        <el-form ref="dataForm" label-width="150px" class="demo-dataForm" style="height: 200px">
          <span v-for="(item,index) in RouteVersionTableModel" :key="index">
            <el-col :span="24">
              <el-form-item :label="item.label" v-if="item.key=='dataAreaId'">
                <el-select size="small" v-model="item.value" @change="CompanyChanged(item)" filterable clearable placeholder="请选择销售公司"
                  class="w-100">
                  <el-option v-for="(t,k) in getCompanyOptions()" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key=='RouteId'">
                <el-select size="small" v-model="item.value" @change="RouteIdChanged(item)" filterable clearable placeholder="请选择工艺编号"
                  class="w-100">
                  <el-option v-for="(t,k) in RouteIdOptions" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key=='ItemId'">
                <el-select size="small" v-model="item.value" filterable remote reserve-keyword :remote-method="ItemIdRemoteMethod" clearable
                  @clear="ItemIdRemoteMethod('')" placeholder="请输入物料关键词" class="w-100">
                  <el-option v-for="(t,k) in InventOptions" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key == 'Name'">
                <el-input type="text" v-model="item.value" readonly></el-input>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key == 'FromQty'">
                <el-input type="number" v-model="item.value" clearable></el-input>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key != 'id' && item.key != 'FromQty'">
                <el-input type="text" v-model="item.value" clearable></el-input>
              </el-form-item>
            </el-col>
          </span>
        </el-form>
      </template>
    </BaseModal>
    <BaseModal ref="route_version_copy_modal" :title="route_version_copy_modal_title" :width="'30%'" @saveData="RouteCopySaveData">
      <template #modal_content>
        <el-form ref="dataForm" label-width="150px" class="demo-dataForm" style="height: 200px">
          <el-col :span="24">
            <el-form-item label="销售公司">
              <el-select size="small" v-model="CopyData.dataAreaId" filterable clearable placeholder="请选择销售公司" class="w-100">
                <el-option v-for="(t,k) in getCompanyOptions()" :key="k" :label="t.label" :value="t.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工艺名称">
              <el-input type="text" v-model="CopyData.Name"></el-input>
            </el-form-item>
            <el-form-item label="物料">
              <el-select size="small" v-model="CopyData.ItemId" filterable remote reserve-keyword :remote-method="ItemIdRemoteMethod" clearable
                @clear="ItemIdRemoteMethod('')" placeholder="请输入物料关键词" class="w-100">
                <el-option v-for="(t,k) in InventOptions" :key="k" :label="t.label" :value="t.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer";
import TableMain from "../components/table/TableMain";
import * as InventTableController from "../../controllers/base/InventTableController";
import * as RouteVersionController from "../../controllers/sd/RouteVersionController";
import * as RouteController from "../../controllers/sd/RouteController";
import * as InventBomVersionController from "../../controllers/sd/InventBomVersionController";
import BaseModal from "../components/modals/baseModal";
import fixedBaseData from "../../../public/js/fixedBaseData"

export default {
  name: "Worker",
  components: {
    BaseContainer,
    TableMain,
    BaseModal
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_route_version_view",
      },
      fields: RouteVersionController.fields.default,
      RouteSearchText: "",
      RouteVersionTableModel: [],
      RouteIdOptions: [],
      InventOptions: [],
      route_version_table1_modal_title: "",
      route_version_copy_modal_title: "版本复制",
      isBusy: false,
      cur_dataAreaId: "",
      CopyData: { id: "", dataAreaId: "", Name: "", ItemId: "", create_by: "" }
    };
  },
  created() {
    let unIncludsFields = ["CompanyName", "SEI_name", "SEI_CustAccount", "InventDimId", "TEC_PackagingReq", "TEC_PostPrintReq",
      "TEC_PrePrintReq", "TEC_ProductRemark", "TEC_Remark", "Active", "is_approved", "approved_by_username", "create_at",
      "create_by_username", "LastAsyncDate", "NameAlias"]
    let fields = _.filter(this.fields, (t) => {
      if (!_.includes(unIncludsFields, t.key)) {
        return t;
      }
    })
    this.RouteVersionTableModel = _.map(fields, (t) => {
      let m = {
        key: t.key,
        label: t.label,
        value: "",
        dataType: "input",
        seq: 0
      }
      return m
    })
    this.RouteVersionTableModel = _.orderBy(this.RouteVersionTableModel, ["seq"], ["asc"])
  },
  methods: {
    getCompanyOptions() {
      return _.map(this.$store.state.biz_data.baseData.CompanyInfo, (v) => {
        return {
          value: v.DataArea,
          label:
            v.DataArea + ":" + (v.CompanyName == null ? "" : v.CompanyName),
        };
      });
    },
    async getRouteIdOptions(_dataAreaId) {
      let p = { is_approved: { "=": 1 }, is_deleted: { "=": 0 } };
      if (_dataAreaId) {
        p.dataAreaId = { "=": _dataAreaId }
      }
      let _result = await RouteController.methods.getRouteIdOptionsData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.RouteIdOptions = _.map(_result[0], (t) => {
          return {
            label: t.RouteId + ":" + t.Name,
            value: t.RouteId,
            text: t.Name
          }
        })
      }
    },
    async CompanyChanged(item) {
      this.cur_dataAreaId = item.value;
      await this.getKvInvent(item.value);
      await this.getRouteIdOptions(item.value)
    },
    RouteIdChanged(item) {
      let m = _.find(this.RouteVersionTableModel, { key: "Name" });
      if (m) {
        let t = _.find(this.RouteIdOptions, { value: item.value });
        if (t) {
          m.value = t.text;
        }
      }
    },
    //#region 查询
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true;
        set_data([]);
      }
      this.RouteSearchText = _.trim(this.RouteSearchText)


      let p = {};
      if (this.RouteSearchText != "") {
        p.SearchText = this.RouteSearchText
      }
      let _result = await RouteVersionController.methods.getData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]));
      }
      this.isBusy = false;
    },
    //#endregion

    //#region 保存
    createForm() {
      this.InventOptions = [];
      this.cur_dataAreaId = "";
      this.route_version_table1_modal_title = "新建工艺版本";
      _.each(this.RouteVersionTableModel, (t) => {
        switch (t.key) {
          case "FromQty": t.value = 1; break;
          default: t.value = ""
        }
      });
      this.$refs.route_version_table1_modal.show()
    },
    ///保存工艺版本
    async RouteVersionSaveData(cb) {
      //数据验证
      let msg = "", am = {}, valid_null_list = ["Name", "dataAreaId", "RouteId", "ItemId"];
      _.each(this.RouteVersionTableModel, (t) => {
        am[t.key] = t.value;
        if (msg == "" && valid_null_list.includes(t.key) && t.value == "") {
          msg = t.label + "不能为空！"
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }

      let p = {};
      am.FromQty = am.FromQty == "" ? 0 : am.FromQty;
      am.ItemId = _.trim(am.ItemId);
      delete am.NameAlias;
      if (am.id == "") {
        delete am.id;
        p.add = am;
      }
      else {
        p.edit = am;
      }
      let rt = await RouteVersionController.methods.saveDataRouteVersion(p);
      if (rt) {
        for (var k in p) {
          if (k == "add") {
            this.$refs.RouteVersionTable1.InsertItems(rt[0])
          }
          else if (k == "edit") {
            let tm = _.find(this.$refs.RouteVersionTable1.my_data, { id: rt[0].id });
            if (tm) {
              Object.assign(tm, rt[0])
            }
          }
        }

        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(false);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    ///保存工艺复制
    async RouteCopySaveData(cb) {
      //数据验证
      let msg = "", am = _.cloneDeep(this.CopyData);
      if (am.Name == "") msg = "请输入工艺名称！";
      else if (!am.ItemId || am.ItemId == "") msg = "请选择物料！";
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }

      let p = { copy: [] };
      p.copy.push(am);
      let rt = await RouteVersionController.methods.saveDataRouteVersion(p);
      if (rt) {
        await this.on_query(this.$refs.RouteVersionTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(false);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      if (data.state != "copy") {
        let ask = await this.msgModal(this.$t("notify.is_continue"));
        if (!ask) {
          cb(false);
          return;
        }
      }

      let p = {};
      if (data.state == "approved" || data.state == "unapproved") {
        let check_dt = _.map(data.selected_items, (t) => {
          return { SearchText: t.RouteId }
        })
        let _result = await RouteController.methods.getData(check_dt);
        if (!_.isNull(_result) && _result && _result.length > 0) {
          let unApprovedItems = [];
          _.each(_result, (lt) => {
            if (!lt[0].is_approved)
              unApprovedItems.push(lt[0].RouteId)
          });
          if (unApprovedItems.length == 0) {
            let dt = _.each(data.selected_items, (t) => { t.is_approved = data.state == "approved"; });
            p.approved = dt;
          }
          else {
            this.msgToasts(_.join(unApprovedItems, ",") + "，工艺路线还未审批暂时不能执行该项审批操作！", "info");
            cb(false);
            return;
          }
        }

      }
      else if (data.state == "valid" || data.state == "invalid") {
        let is_approved = _.some(data.selected_items, ["is_approved", false]);
        if (is_approved) {
          this.msgToasts("未审批数据不能被启用！", "info");
          cb(false);
          return;
        }
        let dt = _.map(data.selected_items, (t) => { t.Active = data.state == "valid"; return { id: t.id, Active: t.Active, ItemId: t.ItemId, dataAreaId: t.dataAreaId } });
        p.valid = dt;
        p.action_state = data.state == "valid";
      }
      else if (data.state == "deleted") {
        let is_active = _.some(data.selected_items, ["Active", true]);
        let is_approved = _.some(data.selected_items, ["is_approved", true]);
        if (is_active || is_approved) {
          this.msgToasts("已审批或已启用数据不能被删除！", "info");
          cb(false);
          return;
        }
        p.delete = data.selected_items;
      }
      else if (data.state == "copy") {
        this.CopyData = { id: "", dataAreaId: "", Name: "", ItemId: "", create_by: "" };
        if (data.selected_items.length > 1) {
          this.msgToasts("每次只能复制一条数据!", "info");
          cb(false);
          return;
        }
        let dt = _.cloneDeep(_.map(data.selected_items, (t) => {
          return { id: t.id, dataAreaId: t.dataAreaId, Name: t.Name, ItemId: t.ItemId, create_by: this.$store.state.biz_data.userInfo.user_id }
        }))
        this.cur_dataAreaId = dt[0].dataAreaId;
        this.ItemIdRemoteMethod(dt[0].ItemId);
        Object.assign(this.CopyData, dt[0]);
        this.$refs.route_version_copy_modal.show();
        cb(false);
        return;

        // let confirm_m = await this.$prompt('工艺名称', '信息确认', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   showCancelButton: false,
        //   inputValue: dt[0].Name
        // })
        // if (confirm_m && confirm_m.action == "confirm") {
        //   dt[0].Name = confirm_m.value;
        // }

        // p.copy = dt
      }

      let rt = await RouteVersionController.methods.saveDataRouteVersion(p);
      if (rt) {
        if (data.state == "deleted")
          this.$refs.RouteVersionTable1.RemoveItems(data.selected_items);
        else
          await this.on_query(this.$refs.RouteVersionTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        };
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data);
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data);
      }
    },
    //#endregion

    ///cell点击
    async on_cell_button_click(data) {
      if (data.item.is_approved) {
        this.msgToasts("已审批或已启用数据不能被变更！", "info");
        return;
      }
      this.route_version_table1_modal_title = "编辑工艺版本"
      for (var k in data.item) {
        let m = _.find(this.RouteVersionTableModel, { key: k });
        if (m) {
          m.value = data.item[k]
        }
      }
      this.cur_dataAreaId = data.item.dataAreaId;
      await this.getKvInvent(data.item.dataAreaId, data.item.ItemId);
      await this.getRouteIdOptions(data.item.dataAreaId);
      this.$refs.route_version_table1_modal.show()
    },

    current_changed(old, current) {

      this.$emit("current_changed", old, current);
    },

    ///根据dataAreaId获取物料
    async getKvInvent(_dataAreaId, query = '') {
      let p = {};
      p.dataAreaId = _dataAreaId;
      p.Query = query;
      // _p.publicItem = 2;
      let _result = await InventTableController.methods.getTop100InventKvData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.InventOptions = _.map(_result[0], (t) => {
          return { value: t.ItemId, label: t.ItemId + ":" + t.NameAlias };
        });
      }
    },
    ///物料下拉
    async ItemIdRemoteMethod(query) {
      await this.getKvInvent(this.cur_dataAreaId, query);
    },

    async InvokeData() {
      let selected_items = this.$refs.RouteVersionTable1.GetSelectedItems();
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        return;
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"));
      if (!ask) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let p = _.map(selected_items, (t) => { return t.RouteId });
      let data = await RouteVersionController.methods.getAsyncData({ code: "Route", params: p });
      let transFields = ["OprPriority", "RouteType"]
      _.each(data[0], (t) => {
        delete t.Detail.dataAreaId;
        t.Detail.Active = t.Active ? 1 : 0;
        t.Detail.Approved = t.Approved ? 1 : 0;
        _.each(t.Detail.Lines, (m) => {
          for (var k in transFields) {
            let key = transFields[k];
            if (m[key] == "" || !m[key])
              m[key] = 0
            else {
              let pm = _.find(fixedBaseData[key], { label: m[key] });
              if (pm)
                m[key] = pm.value;
            }
          }
        })
      })
      let rt = await InventBomVersionController.methods.asyncDataToAX(data[0], this);
      console.log(rt)
      if (rt && rt.state) {
        let upd_p = _.map(selected_items, (t) => {
          return { id: t.id, LastAsyncDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss") };
        })
        let upd_rt = await RouteVersionController.methods.saveDataRouteVersion({ edit: upd_p });
        await this.on_query(this.$refs.RouteVersionTable1.SetData, false);
      }
      else if (rt && !rt.state) {
        this.msgToasts(rt.message, "info");
      }
      loading.close();
    },
    RouteDiff() {
      let selected_items = this.$refs.RouteVersionTable1.GetSelectedItems();
      if (selected_items.length == 0) {
        return;
      }
      else if (selected_items.length > 2) {
        this.msgToasts("目前对比只能针对两个版本进行！", "info");
        return;
      }
      this.$emit("goRouteDiff", { RouteVersion1: selected_items[0].RouteId, RouteVersion2: selected_items[1].RouteId });
    }
  },
};
</script>
